<template>
  <div>
    <loginHeader></loginHeader>
    <div class="login_bg">
      <img @click="go_login()" class="scan_code" width="35px" height="29px" src="../assets/images/pc.png" alt />
      <h3>手机扫码，安全登录</h3>
      <div class="qr_code"></div>
      <p class="go_register">
        请使用
        <a href>担当APP</a> |
        <a href>微信</a> 扫一扫登录
      </p>
    </div>

    <div class="login_success">
      <img @click="go_login()" class="scan_code" width="35px" height="29px" src="../assets/images/pc.png" alt />
      <h3>手机扫码，安全登录</h3>
      <div class="qr_code"></div>
      <p class="go_register">登录成功</p>
    </div>

    <div class="login_internet_fail">
      <img @click="go_login()" class="scan_code" width="35px" height="29px" src="../assets/images/pc.png" alt />
      <h3>手机扫码，安全登录</h3>
      <div class="qr_code">
        <img width="32px" height="39px" src="../assets/images/fail.png" alt />
        <p>网络连接失败</p>
      </div>
      <p class="go_register">登录成功</p>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    loginHeader: () => import(/* webpackChunkName: "design" */ "../components/login_header"),
  },
  methods:{
    go_login(){
      this.$router.push({
        path: `/`
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.login_bg {
  width: 484px;
  height: 505px;
  margin: 114px auto 0;
  background: url("../assets/login_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  padding: 24px 61px 75px;
  box-sizing: border-box;
  position: relative;
  // display: none;
}
h3 {
  text-align: center;
  font-size: 15px;
  font-weight: 400;
  margin-top: 51px;
}
.qr_code {
  width: 174px;
  height: 174px;
  background: pink;
  margin: 50px auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.scan_code {
  position: absolute;
  left: 400px;
  cursor: pointer;
}
.go_register {
  color: rgba(102, 102, 102, 1);
  font-size: 13px;
  font-weight: 400;
  text-align: center;
}
a {
  color: rgba(64, 166, 255, 1);
  font-size: 13px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  text-decoration: none;
}
.login_success {
  width: 484px;
  height: 505px;
  margin: 114px auto 0;
  background: url("../assets/login_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  padding: 24px 61px 75px;
  box-sizing: border-box;
  position: relative;
  display: none;
}
.login_internet_fail {
  width: 484px;
  height: 505px;
  margin: 114px auto 0;
  background: url("../assets/login_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  padding: 24px 61px 75px;
  box-sizing: border-box;
  position: relative;
  display: none;
}
</style>
